export default "__VITE_ASSET__GJjo6byu__"